import { render, staticRenderFns } from "./DeferredVideo.vue?vue&type=template&id=5122263a&scoped=true&"
import script from "./DeferredVideo.vue?vue&type=script&lang=js&"
export * from "./DeferredVideo.vue?vue&type=script&lang=js&"
import style0 from "./DeferredVideo.vue?vue&type=style&index=0&id=5122263a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5122263a",
  null
  
)

export default component.exports